import { connect } from 'react-redux';
import Progress from '../../../features/progress/shared/Progress';
import { selectors } from '../../../root/reading/root';
import LinkWrapper from '../../../features/navigation/LinkWrapper';
import {
    getProgressTabs,
    getProgressPageConfig,
} from '../../../features/progress/shared/progressHelper';
import ProgressHeaderContainer from './ProgressHeaderContainer';
import BasicComprehensionsWebEntryContainer from '../../probeDetails/reading/mazeWebEntry/MazeWebEntryContainer';
import { BASE_URLS, getMainHelpUrl } from '../../../constants/reading/ApiConstants';
import { LICENSE } from '../../../constants/reading/CommonConstants';
import { basicComprehensionGradesMap } from '../../../constants/shared/GradesConstants';
import { lrsSwitchProgressTab } from '../../../api/lrs/shared/lrsActions';
import { SUPPORTED_GRADES_WITH_BC } from '../../../constants/shared/WebEntryConstants';
import ZonesOfGrowthTableContainer from './zonesOfGrowth/ZonesOfGrowthTableContainer';
import GrowthAnalysisTableContainer from './growthAnalysis/GrowthAnalysisTableContainer';
import ProgressTableContainer from './progressReview/ProgressTableContainer';

const mapStateToProps = state => {
    const licensingInfo = selectors.getLicensingInfo(state);
    const gradeToMeasureMapper = selectors.getGradeToMeasureMapper(state);
    const { GRADES_WITH_BC, GRADES_WITHOUT_BC } = basicComprehensionGradesMap(gradeToMeasureMapper);

    return {
        location: selectors.getLocation(state),
        currentPeriod: selectors.getCurrentPeriod(state),
        selectedPmPeriod: selectors.getSelectedPmPeriod(state),
        selectedGrowthAnalysisPeriod: selectors.getSelectedGrowthAnalysisPeriod(state),
        licensingInfo,
        LinkWrapper,
        getProgressPageConfig,
        getProgressTabs,
        ProgressHeaderContainer,
        BasicComprehensionsWebEntryContainer,
        getMainHelpUrl,
        isBurst: licensingInfo.includes(LICENSE.BURST),
        gradesWithoutBC: GRADES_WITHOUT_BC,
        gradesWithBC: GRADES_WITH_BC,
        supportedGradesWithBC: SUPPORTED_GRADES_WITH_BC,
        tablesContainers: {
            ProgressTableContainer,
            ZonesOfGrowthTableContainer,
            GrowthAnalysisTableContainer,
        },
        progressUrl: BASE_URLS.PROGRESS_URL,
        toyPeriods: selectors.getToyPeriods(state),
    };
};

const mapDispatchToProps = dispatch => ({
    lrsSwitchProgressTab: ({ selectedTab, selectedPeriod }) => {
        dispatch(lrsSwitchProgressTab({ selectedTab, selectedPeriod }));
    },
});

export default connect(mapStateToProps, mapDispatchToProps)(Progress);
